import './ProductComparisonToolbar.less';
import Button from '../../button/Button';
import useAppSelector from '../../../hooks/useAppSelector';
import { Product } from '../../../models/Product';
import useAppDispatch from '../../../hooks/useAppDispatch';
import Icon from '../../icon/Icon';
import { useCallback, useEffect, useState } from 'preact/hooks';
import IconButton from '../../button/IconButton';
import { useTranslation } from '../../../hooks/useTranslation';

const ProductComparisonToolbar = () => {
    const { selectedProducts, selectedProductIds, loadingProductIds } =
        useAppSelector(state => state.productComparisonState);
    const [selectedProductImages, setSelectedProductImages] = useState({
        first: '',
        second: '',
        third: ''
    });
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const clearSelectedProducts = useCallback(() => {
        dispatch.productComparisonState.clearSelectedProducts();
    }, [dispatch]);

    const startProductComparison = useCallback(() => {
        void dispatch.featureState.startFeature({
            featureType: 'product-comparison'
        });
    }, [dispatch]);
    useEffect(() => {
        if (selectedProducts.length > 0) {
            setSelectedProductImages(s => ({
                ...s,
                first: `url('${selectedProducts[0].images[0].url}')`
            }));
        }
        if (selectedProducts.length > 1) {
            setSelectedProductImages(s => ({
                ...s,
                second: `url('${selectedProducts[1].images[0].url}')`
            }));
        }
        if (selectedProducts.length > 2) {
            setSelectedProductImages(s => ({
                ...s,
                third: `url('${selectedProducts[2].images[0].url}')`
            }));
        }
    }, [selectedProductIds, selectedProducts]);
    const getCard = useCallback(
        (className: string, backgroundImage: string, product?: Product) => {
            return (
                <div
                    className={`bri-product-card ${className} ${
                        product ? 'bri-filled' : ''
                    }`}
                >
                    {!product && <Icon iconId="compare" />}
                    <div
                        className={`bri-inner-image`}
                        style={{
                            backgroundImage
                        }}
                    ></div>
                    {product && (
                        <button
                            type="button"
                            className={'bri-remove-button'}
                            onClick={() =>
                                dispatch.productComparisonState.toggleProductSelection(
                                    product.productId
                                )
                            }
                        >
                            <Icon iconId="close" />
                        </button>
                    )}
                </div>
            );
        },
        [dispatch]
    );
    const isVisible = selectedProductIds.length > 0;
    const isCompareButtonDisabled =
        selectedProducts.length < 2 || loadingProductIds.length > 0;
    return (
        <div
            className={`bri-ProductComparisonToolbar ${
                isVisible ? 'bri-visible' : ''
            }`}
        >
            {getCard(
                'bri-first',
                selectedProductImages.first,
                selectedProducts[0]
            )}
            {getCard(
                'bri-second',
                selectedProductImages.second,
                selectedProducts[1]
            )}
            {getCard(
                'bri-third',
                selectedProductImages.third,
                selectedProducts[2]
            )}
            <div className="bri-buttons-container">
                <Button
                    size="medium"
                    variant="magic"
                    disabled={isCompareButtonDisabled}
                    onClick={startProductComparison}
                    title={
                        isCompareButtonDisabled
                            ? t('COMPARISON_TOOLBAR_DISABLED_BUTTON_TITLE')
                            : ''
                    }
                >
                    {t('COMPARISON_TOOLBAR_BUTTON_LABEL')}
                </Button>
                <IconButton
                    variant="light"
                    size="x-small"
                    disabled={selectedProducts.length === 0}
                    iconId="close"
                    className="bri-ProductComparisonToolbar-clear"
                    onClick={clearSelectedProducts}
                />
            </div>
        </div>
    );
};

export default ProductComparisonToolbar;
